/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_LiveInputs */

const en_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const ar_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#مباشر`)
};

const bn_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const de_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const es_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const fr_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const pt_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const zh_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const tr_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const ru_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

const pl_svtag_live = /** @type {(inputs: Svtag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#LIVE`)
};

/**
* | output |
* | --- |
* | "#LIVE" |
*
* @param {Svtag_LiveInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_live = /** @type {((inputs?: Svtag_LiveInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_LiveInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_live(inputs)
	if (locale === "bn") return bn_svtag_live(inputs)
	if (locale === "de") return de_svtag_live(inputs)
	if (locale === "es") return es_svtag_live(inputs)
	if (locale === "fr") return fr_svtag_live(inputs)
	if (locale === "pt") return pt_svtag_live(inputs)
	if (locale === "zh") return zh_svtag_live(inputs)
	if (locale === "tr") return tr_svtag_live(inputs)
	if (locale === "ru") return ru_svtag_live(inputs)
	if (locale === "pl") return pl_svtag_live(inputs)
	return en_svtag_live(inputs)
});